export default __webpack_public_path__ + "7925e1c8b27afccb83ac36d9b86f3b7f.png";